import { IconProps } from '.';

export const PagesCheckmarkIcon = ({ className, color = 'var(--color-primary)' }: IconProps) => {
  return (
    <svg
      className={className}
      width='60'
      height='60'
      viewBox='0 0 60 60'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M57 30C57 44.9117 44.9117 57 30 57C25.6895 57 21.6149 55.9899 18 54.1934V27C18 22.0294 22.0294 18 27 18H54.1934C55.9899 21.6149 57 25.6895 57 30ZM43.0924 57L43.0062 57.0417C39.3176 58.8191 35.2095 59.8639 30.8708 59.9876C30.5815 59.9958 30.2913 60 30 60C25.5603 60 21.3458 59.0356 17.5546 57.3048C16.6797 56.9054 15.8274 56.4651 15 55.9865C12.8099 54.7196 10.7949 53.1838 9 51.4243C7.9242 50.3696 6.92747 49.2346 6.01958 48.029C2.24027 43.01 0 36.7666 0 30C0 13.4315 13.4315 0 30 0C41.1042 0 50.7994 6.03298 55.9865 15C56.1204 15.2315 56.2513 15.4649 56.3792 15.7002C58.6883 19.951 60 24.8223 60 30C60 31.7036 59.858 33.374 59.5852 35C59.1063 37.8543 58.2245 40.572 57 43.0924C54.0598 49.1447 49.1446 54.0598 43.0924 57ZM15 52.4534C12.7342 50.9366 10.7107 49.0861 9 46.972V36C9 32.0813 11.5044 28.7476 15 27.5121V52.4534ZM27 15C21.2995 15 16.5274 18.9748 15.304 24.304C9.97479 25.5274 6 30.2995 6 36V42.3816C4.08279 38.6729 3 34.4629 3 30C3 15.0883 15.0883 3 30 3C39.3612 3 47.6098 7.76409 52.4534 15H27ZM44.5607 31.0607L42.4393 28.9393L34.5 36.8787L31.0607 33.4393L28.9393 35.5607L33.4393 40.0607L34.5 41.1213L35.5607 40.0607L44.5607 31.0607Z'
        fill={color}
      />
    </svg>
  );
};
